/**
 * Product Card — front-end interactions.
 *
 * Handles:
 *   1. Format button clicks → swap image, price, active variation
 *   2. Add to Cart → custom WC AJAX endpoint (mpwn_add_to_cart)
 *
 * Shared by both product-card and product-grid blocks.
 */
( function () {
	'use strict';

	/**
	 * Initialise a single product card.
	 *
	 * @param {HTMLElement} card The .mpw-product-card element.
	 */
	function initCard( card ) {
		var rawJson    = card.getAttribute( 'data-variations' );
		var variations = [];

		if ( rawJson ) {
			try {
				variations = JSON.parse( rawJson );
			} catch ( e ) {
				// No-op — card works without variation switching.
			}
		}

		// ── Format button switching ──
		var formatBtns = card.querySelectorAll( '.mpw-product-card__format-btn' );
		var image      = card.querySelector( '.mpw-product-card__image' );
		var imageLink  = card.querySelector( '.mpw-product-card__image-link' );
		var priceEl    = card.querySelector( '.mpw-product-card__price' );
		var addBtn     = card.querySelector( '.mpw-product-card__add-btn' );

		formatBtns.forEach( function ( btn ) {
			btn.addEventListener( 'click', function () {
				var varId = parseInt( btn.getAttribute( 'data-variation-id' ), 10 );
				var match = null;

				for ( var i = 0; i < variations.length; i++ ) {
					if ( variations[ i ].id === varId ) {
						match = variations[ i ];
						break;
					}
				}

				if ( ! match ) return;

				// Update active state.
				formatBtns.forEach( function ( b ) {
					b.classList.remove( 'mpw-product-card__format-btn--active' );
				} );
				btn.classList.add( 'mpw-product-card__format-btn--active' );

				// Swap image with crossfade.
				if ( image && match.image ) {
					image.style.opacity = '0';
					setTimeout( function () {
						image.src = match.image;
						if ( match.imageSrcset ) {
							image.srcset = match.imageSrcset;
						}
						if ( match.imageSizes ) {
							image.sizes = match.imageSizes;
						}
						image.style.opacity = '1';
					}, 150 );
				}

				// Swap image link href so clicking the image goes to the selected variation.
				if ( imageLink && match.url ) {
					imageLink.setAttribute( 'href', match.url );
				}

				// Swap price.
				if ( priceEl && match.priceHtml ) {
					priceEl.innerHTML = match.priceHtml;
				}

				// Update add-to-cart variation ID.
				if ( addBtn ) {
					addBtn.setAttribute( 'data-variation-id', varId );
				}
			} );
		} );

		// ── Add to Cart ──
		if ( addBtn ) {
			addBtn.addEventListener( 'click', function ( e ) {
				e.preventDefault();

				if ( addBtn.classList.contains( 'mpw-product-card__add-btn--loading' ) ) {
					return;
				}

				var productId   = parseInt( addBtn.getAttribute( 'data-product-id' ), 10 );
				var variationId = parseInt( addBtn.getAttribute( 'data-variation-id' ), 10 ) || 0;
				var originalText = addBtn.textContent;

				addBtn.classList.add( 'mpw-product-card__add-btn--loading' );
				addBtn.textContent = '\u2026';

				// Build form data for WooCommerce AJAX.
				var formData = new FormData();
				formData.append( 'product_id', productId );
				formData.append( 'quantity', '1' );

				if ( variationId > 0 ) {
					formData.append( 'variation_id', variationId );

					// Find the matching variation for its attribute key.
					for ( var i = 0; i < variations.length; i++ ) {
						if ( variations[ i ].id === variationId ) {
							if ( variations[ i ].attrKey && variations[ i ].slug ) {
								formData.append( variations[ i ].attrKey, variations[ i ].slug );
							}
							break;
						}
					}
				}

				// Use our custom AJAX handler that supports variable products.
				fetch( '/?wc-ajax=mpwn_add_to_cart', {
					method: 'POST',
					body: formData,
					credentials: 'same-origin',
				} )
				.then( function ( response ) {
					// Capture the ok status before parsing body.
					var ok = response.ok;
					return response.text().then( function ( text ) {
						return { ok: ok, text: text };
					} );
				} )
				.then( function ( res ) {
					// Try to parse JSON for fragments.
					var result = null;
					try {
						result = JSON.parse( res.text );
					} catch ( e1 ) {
						// Response may have trailing chars — trim to last }.
						try {
							var end = res.text.lastIndexOf( '}' );
							if ( end > 0 ) {
								result = JSON.parse( res.text.substring( 0, end + 1 ) );
							}
						} catch ( e2 ) { /* give up */ }
					}

					// Success if HTTP 200 OR parsed result says success.
					if ( res.ok || ( result && result.success ) ) {
						addBtn.textContent = '\u2713 Added';

						// Fire WC event so sidebar cart / mini-cart updates.
						if ( result && typeof jQuery !== 'undefined' ) {
							jQuery( document.body ).trigger( 'added_to_cart', [
								result.fragments || {},
								result.cart_hash || '',
								jQuery( addBtn ),
							] );
						}
					} else {
						addBtn.textContent = 'Error';
					}
				} )
				.catch( function () {
					// Network error — item may still have been added.
					addBtn.textContent = 'Error';
				} )
				.finally( function () {
					setTimeout( function () {
						addBtn.textContent = originalText;
						addBtn.classList.remove( 'mpw-product-card__add-btn--loading' );
					}, 1500 );
				} );
			} );
		}
	}

	// ── Initialise all cards on the page ──
	function init() {
		var cards = document.querySelectorAll( '.mpw-product-card[data-product-id]' );
		cards.forEach( initCard );
	}

	if ( document.readyState === 'loading' ) {
		document.addEventListener( 'DOMContentLoaded', init );
	} else {
		init();
	}
} )();
